import styles from "./NewsSkeleton.module.scss";

export const NewsSkeleton = () => {
  return (
    <div className={styles.skeletonWrapper}>
      <div className={`${styles.skeletonContainer}`} />
      <div className={`${styles.skeletonContainer}`} />
      <div className={`${styles.skeletonContainer}`} />
      <div className={`${styles.skeletonContainer}`} />
    </div>
  )
}